import React, {Component} from 'react';
import {Button, Icon, Label, Segment, Tab} from "semantic-ui-react";
import moment from "moment";
import {opacityFromDate} from "../../utils";

export default class InteractiveMapLineSegment extends Component {

    render() {

        const {route, active, now, ship, legs} = this.props;
        let panes = [];

        return (!route.request || (route.request && active)) && <Segment className="line" onClick={this.props.onClick} secondary={active}
                        id={"InteractiveMapLineSegment" + route.id}>

            <div className="bar" style={{opacity: opacityFromDate(route.departure.date, now, undefined, route.request)}}/>
            {/*<h2>*/}
            {/*{route.departure.city} <Icon name="arrow right" /> {route.arrival.city}*/}
            {/*</h2>*/}

            <div className="top-part departure">
                <h2>{route.departure.country}</h2>
                <h3>{!route.request && moment(route.departure.date).format("D MMMM Y")}</h3>
                <h4>{route.departure.city}</h4>
            </div>

            <div className="top-part arrival">
                <h2>{route.arrival.country}</h2>
                <h3>{!route.request && moment(route.arrival.date).format("D MMMM Y")}</h3>
                <h4>{route.arrival.city}</h4>
            </div>

            <br style={{clear: "both"}}/>

            {route.request ? <div>
                    <Label size={active ? "small" : "mini"}>Requested route</Label>
                   {active && <Button color="blue" size="mini">
                        Request
                    </Button>}
                </div> :
                <div>
                    <Label basic size={active ? "small" : "mini"}><Icon
                        name="clock"/>{route.duration} days</Label>
                    {route.cost &&
                    <Label basic size={active ? "small" : "mini"}>€ {route.cost}</Label>}
                    {active && <Button color="blue" size="mini">
                        Book
                    </Button>}
                </div>}

            {active && ship && <div className="ship-info">
                {/*<div className="ship-photos">*/}
                {/*{ship.photos && ship.photos.map((photo, i) => <img src={photo} key={ship.id + "photo" + i}/>)}*/}
                {/*</div>*/}
                {ship.photos && <img src={ship.photos[0]} key={ship.id + "photo"}
                                     alt={ship.name + ", source: " + ship.photoSourceUrl}/>}
                <strong>{ship.name}</strong><br />
                {ship.introduction.substr(0, 150) + "..."}
                <span className="read-more">Read More</span>
                <br style={{clear: "both"}} />
                </div>}

                </Segment>;
                }
            }


// WEBPACK FOOTER //
// ./src/components/interactive-map/InteractiveMapLineSegment.js